import __request__ from "routing/request";
export function bulkRemove(Entitiestoremove, requestOptions) {
  return __request__("POST", "/datanode/bulk_remove", Entitiestoremove, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function bulkStart(Entitiestostart, requestOptions) {
  return __request__("POST", "/datanode/bulk_start", Entitiestostart, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function bulkStop(Entitiestostop, requestOptions) {
  return __request__("POST", "/datanode/bulk_stop", Entitiestostop, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function runsWithDataNode(requestOptions) {
  return __request__("GET", "/datanode/configured", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function removeNode(nodeId, requestOptions) {
  return __request__("DELETE", `/datanode/${nodeId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getDataNode(nodeId, requestOptions) {
  return __request__("GET", `/datanode/${nodeId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function resetNode(nodeId, requestOptions) {
  return __request__("POST", `/datanode/${nodeId}/reset`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function startNode(nodeId, requestOptions) {
  return __request__("POST", `/datanode/${nodeId}/start`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function stopNode(nodeId, requestOptions) {
  return __request__("POST", `/datanode/${nodeId}/stop`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
